import { createFileRoute } from '@tanstack/react-router';

import { SchemaDriftTab } from '../../components/SchemaDriftTab';

export const Route = createFileRoute('/db-insights/drift')({
  component: SchemaDriftTab
});
